import React from 'react';

type Props = {
  id: string;
  label?: string,
  checked?: boolean,
  onChange?: React.ChangeEventHandler<HTMLInputElement>,
  onBlur?: React.FocusEventHandler<HTMLInputElement>,
  className?: string;
};

// This component mimics the livewire toggle component
// at /resources/views/partials/formInputs/toggle.blade.php
const ToggleInput: React.FC<Props> = (data) => {
  const {
    id,
    label,
    checked = false,
    onChange,
    onBlur,
    className = '',
  } = data;

  return (
    <div className={`toggle-slider-container d-flex align-items-center ${className}`}>
      <label className="toggle-inner-container mb-0" htmlFor={id}>
        <input
          id={id}
          type="checkbox"
          className="toggle-slider-input"
          onChange={onChange}
          onBlur={onBlur}
          checked={checked}
        />
        <span className="toggle-slider" />
      </label>
      { !!label
        && <span className="ml-3">{label}</span>}
    </div>
  );
};

export default ToggleInput;
